// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1bbTD","footer":"ModalError_footer__3LbSj"};